import { render, staticRenderFns } from "./AbnormalStock.vue?vue&type=template&id=4060240f&scoped=true&"
import script from "./AbnormalStock.vue?vue&type=script&lang=js&"
export * from "./AbnormalStock.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalStock.vue?vue&type=style&index=0&id=4060240f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060240f",
  null
  
)

export default component.exports